import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation resources
const resources = {
  fr: {
    translation: {
      // Common
      common: {
        loading: 'Chargement...',
        save: 'Enregistrer',
        cancel: 'Annuler',
        delete: 'Supprimer',
        edit: 'Modifier',
        create: 'Créer',
        search: 'Rechercher',
        filter: 'Filtrer',
        export: 'Exporter',
        actions: 'Actions',
        yes: 'Oui',
        no: 'Non',
        confirm: 'Confirmer',
        back: 'Retour',
        next: 'Suivant',
        previous: 'Précédent',
        submit: 'Soumettre',
        close: 'Fermer',
        success: 'Succès',
        error: 'Erreur',
        warning: 'Attention',
        info: 'Information',
      },
      // Navigation
      nav: {
        dashboard: 'Tableau de bord',
        jobs: 'Offres d\'emploi',
        applications: 'Candidatures',
        surveys: 'Sondages',
        quizzes: 'Quiz',
        admin: 'Administration',
        settings: 'Paramètres',
        logout: 'Déconnexion',
        profile: 'Profil',
      },
      // Auth
      auth: {
        login: 'Connexion',
        register: 'Inscription',
        email: 'Email',
        password: 'Mot de passe',
        confirmPassword: 'Confirmer le mot de passe',
        firstName: 'Prénom',
        lastName: 'Nom',
        forgotPassword: 'Mot de passe oublié ?',
        noAccount: 'Pas encore de compte ?',
        hasAccount: 'Déjà un compte ?',
        loginError: 'Email ou mot de passe incorrect',
        registerSuccess: 'Compte créé avec succès',
      },
      // Dashboard
      dashboard: {
        title: 'Tableau de bord',
        welcome: 'Bienvenue',
        totalJobs: 'Offres actives',
        activeJobs: 'Offres actives',
        totalApplications: 'Candidatures',
        applications: 'Candidatures',
        pendingApplications: 'En attente',
        pending: 'En attente',
        totalSurveys: 'Sondages actifs',
        activeSurveys: 'Sondages actifs',
        recentApplications: 'Candidatures récentes',
        applicationsTrend: 'Tendance des candidatures',
        stats: 'Statistiques',
      },
      // Jobs
      jobs: {
        title: 'Offres d\'emploi',
        createJob: 'Créer une offre',
        editJob: 'Modifier l\'offre',
        jobTitle: 'Titre du poste',
        description: 'Description',
        requirements: 'Exigences',
        responsibilities: 'Responsabilités',
        location: 'Lieu',
        type: 'Type de contrat',
        salary: 'Salaire',
        status: 'Statut',
        publishedAt: 'Publié le',
        expiresAt: 'Expire le',
        applicationsCount: 'Nombre de candidatures',
        viewApplications: 'Voir les candidatures',
        publicLink: 'Lien public',
        copyLink: 'Copier le lien',
        linkCopied: 'Lien copié !',
        types: {
          FULL_TIME: 'Temps plein',
          PART_TIME: 'Temps partiel',
          CONTRACT: 'Contrat',
          INTERNSHIP: 'Stage',
          REMOTE: 'Télétravail',
        },
        statuses: {
          DRAFT: 'Brouillon',
          PUBLISHED: 'Publié',
          CLOSED: 'Fermé',
          ARCHIVED: 'Archivé',
        },
      },
      // Applications
      applications: {
        title: 'Candidatures',
        candidate: 'Candidat',
        job: 'Poste',
        status: 'Statut',
        submittedAt: 'Soumis le',
        viewDetails: 'Voir les détails',
        downloadCV: 'Télécharger le CV',
        notes: 'Notes',
        changeStatus: 'Changer le statut',
        statuses: {
          PENDING: 'En attente',
          REVIEWING: 'En cours d\'examen',
          SHORTLISTED: 'Présélectionné',
          INTERVIEW: 'Entretien',
          OFFERED: 'Offre faite',
          HIRED: 'Embauché',
          REJECTED: 'Rejeté',
          WITHDRAWN: 'Retiré',
        },
      },
      // Surveys
      surveys: {
        title: 'Sondages',
        createSurvey: 'Créer un sondage',
        editSurvey: 'Modifier le sondage',
        surveyTitle: 'Titre du sondage',
        description: 'Description',
        questions: 'Questions',
        addQuestion: 'Ajouter une question',
        addSection: 'Ajouter une section',
        responses: 'Réponses',
        viewResults: 'Voir les résultats',
        publicLink: 'Lien du sondage',
        status: 'Statut',
        statuses: {
          DRAFT: 'Brouillon',
          ACTIVE: 'Actif',
          CLOSED: 'Fermé',
          ARCHIVED: 'Archivé',
        },
        questionTypes: {
          TEXT: 'Texte court',
          TEXTAREA: 'Texte long',
          NUMBER: 'Nombre',
          SELECT: 'Liste déroulante',
          MULTISELECT: 'Choix multiples',
          RADIO: 'Choix unique',
          CHECKBOX: 'Cases à cocher',
          SCALE: 'Échelle',
          DATE: 'Date',
          FILE: 'Fichier',
        },
      },
      // Public forms
      public: {
        applicationTitle: 'Candidature pour',
        applicationSuccess: 'Votre candidature a été soumise avec succès !',
        surveyTitle: 'Sondage',
        surveySuccess: 'Merci pour votre participation !',
        expiredLink: 'Ce lien a expiré',
        invalidLink: 'Lien invalide',
      },
      // Admin
      admin: {
        title: 'Administration',
        users: 'Utilisateurs',
        companies: 'Entreprises',
        allCandidates: 'Tous les candidats',
        allApplications: 'Toutes les candidatures',
        settings: 'Paramètres système',
      },
      // Validation
      validation: {
        required: 'Ce champ est requis',
        email: 'Email invalide',
        minLength: 'Minimum {{min}} caractères',
        maxLength: 'Maximum {{max}} caractères',
        passwordMatch: 'Les mots de passe ne correspondent pas',
        invalidFile: 'Type de fichier non autorisé',
        fileTooLarge: 'Fichier trop volumineux (max {{max}})',
      },
    },
  },
  en: {
    translation: {
      // Common
      common: {
        loading: 'Loading...',
        save: 'Save',
        cancel: 'Cancel',
        delete: 'Delete',
        edit: 'Edit',
        create: 'Create',
        search: 'Search',
        filter: 'Filter',
        export: 'Export',
        actions: 'Actions',
        yes: 'Yes',
        no: 'No',
        confirm: 'Confirm',
        back: 'Back',
        next: 'Next',
        previous: 'Previous',
        submit: 'Submit',
        close: 'Close',
        success: 'Success',
        error: 'Error',
        warning: 'Warning',
        info: 'Information',
      },
      // Navigation
      nav: {
        dashboard: 'Dashboard',
        jobs: 'Job Postings',
        applications: 'Applications',
        surveys: 'Surveys',
        quizzes: 'Quizzes',
        admin: 'Administration',
        settings: 'Settings',
        logout: 'Logout',
        profile: 'Profile',
      },
      // Auth
      auth: {
        login: 'Login',
        register: 'Register',
        email: 'Email',
        password: 'Password',
        confirmPassword: 'Confirm Password',
        firstName: 'First Name',
        lastName: 'Last Name',
        forgotPassword: 'Forgot password?',
        noAccount: 'Don\'t have an account?',
        hasAccount: 'Already have an account?',
        loginError: 'Invalid email or password',
        registerSuccess: 'Account created successfully',
      },
      // Dashboard
      dashboard: {
        title: 'Dashboard',
        welcome: 'Welcome',
        totalJobs: 'Active Jobs',
        totalApplications: 'Applications',
        pendingApplications: 'Pending',
        totalSurveys: 'Active Surveys',
        recentApplications: 'Recent Applications',
        applicationsTrend: 'Applications Trend',
        stats: 'Statistics',
      },
      // Jobs
      jobs: {
        title: 'Job Postings',
        createJob: 'Create Job',
        editJob: 'Edit Job',
        jobTitle: 'Job Title',
        description: 'Description',
        requirements: 'Requirements',
        responsibilities: 'Responsibilities',
        location: 'Location',
        type: 'Contract Type',
        salary: 'Salary',
        status: 'Status',
        publishedAt: 'Published On',
        expiresAt: 'Expires On',
        applicationsCount: 'Applications',
        viewApplications: 'View Applications',
        publicLink: 'Public Link',
        copyLink: 'Copy Link',
        linkCopied: 'Link copied!',
        types: {
          FULL_TIME: 'Full Time',
          PART_TIME: 'Part Time',
          CONTRACT: 'Contract',
          INTERNSHIP: 'Internship',
          REMOTE: 'Remote',
        },
        statuses: {
          DRAFT: 'Draft',
          PUBLISHED: 'Published',
          CLOSED: 'Closed',
          ARCHIVED: 'Archived',
        },
      },
      // Applications
      applications: {
        title: 'Applications',
        candidate: 'Candidate',
        job: 'Position',
        status: 'Status',
        submittedAt: 'Submitted On',
        viewDetails: 'View Details',
        downloadCV: 'Download CV',
        notes: 'Notes',
        changeStatus: 'Change Status',
        statuses: {
          PENDING: 'Pending',
          REVIEWING: 'Under Review',
          SHORTLISTED: 'Shortlisted',
          INTERVIEW: 'Interview',
          OFFERED: 'Offered',
          HIRED: 'Hired',
          REJECTED: 'Rejected',
          WITHDRAWN: 'Withdrawn',
        },
      },
      // Surveys
      surveys: {
        title: 'Surveys',
        createSurvey: 'Create Survey',
        editSurvey: 'Edit Survey',
        surveyTitle: 'Survey Title',
        description: 'Description',
        questions: 'Questions',
        addQuestion: 'Add Question',
        addSection: 'Add Section',
        responses: 'Responses',
        viewResults: 'View Results',
        publicLink: 'Survey Link',
        status: 'Status',
        statuses: {
          DRAFT: 'Draft',
          ACTIVE: 'Active',
          CLOSED: 'Closed',
          ARCHIVED: 'Archived',
        },
        questionTypes: {
          TEXT: 'Short Text',
          TEXTAREA: 'Long Text',
          NUMBER: 'Number',
          SELECT: 'Dropdown',
          MULTISELECT: 'Multiple Choice',
          RADIO: 'Single Choice',
          CHECKBOX: 'Checkboxes',
          SCALE: 'Scale',
          DATE: 'Date',
          FILE: 'File',
        },
      },
      // Public forms
      public: {
        applicationTitle: 'Application for',
        applicationSuccess: 'Your application has been submitted successfully!',
        surveyTitle: 'Survey',
        surveySuccess: 'Thank you for your participation!',
        expiredLink: 'This link has expired',
        invalidLink: 'Invalid link',
      },
      // Admin
      admin: {
        title: 'Administration',
        users: 'Users',
        companies: 'Companies',
        allCandidates: 'All Candidates',
        allApplications: 'All Applications',
        settings: 'System Settings',
      },
      // Validation
      validation: {
        required: 'This field is required',
        email: 'Invalid email',
        minLength: 'Minimum {{min}} characters',
        maxLength: 'Maximum {{max}} characters',
        passwordMatch: 'Passwords do not match',
        invalidFile: 'File type not allowed',
        fileTooLarge: 'File too large (max {{max}})',
      },
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'fr',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  });

export default i18n;
